<h2 mat-dialog-title style="text-align: center;">{{data.title}}</h2>
<mat-dialog-content class="mat-typography">
  <!--<h3 *ngIf="data.timeseries?.length == 0">{{data.content}} -> {{data.id}}</h3>-->
  <div *ngIf="data.wait" fxLayout="row" fxLayoutAlign="space-around center" style="text-align: center;">
    <mat-spinner [diameter]="75"></mat-spinner>
  </div>
  <div *ngIf="data.type == 0 && data.option == -1 && data.id == -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="addCampaignForm">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Gunitadora</mat-label>
            <input matInput [value]="data.disp" formControlName="dispUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Campaña</mat-label>
            <input matInput [value]="data.name" formControlName="campaignName">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="campaignStartDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="campaignEndDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 2 && data.option == -1 && data.id == -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="addSteelProductionForm">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Gunitadora</mat-label>
            <input matInput [value]="data.disp" formControlName="dispUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Acero</mat-label>
            <input matInput formControlName="steelConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Número de Coladas</mat-label>
            <input matInput formControlName="steelCastings">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 3 && data.option == -1 && data.id == -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="addFrimagConsumptionForm">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Gunitadora</mat-label>
            <input matInput [value]="data.disp" formControlName="dispUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Frimag</mat-label>
            <input matInput formControlName="frimagConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 4 && data.option == -1 && data.id == -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="addMagsolConsumptionForm">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Gunitadora</mat-label>
            <input matInput [value]="data.disp" formControlName="dispUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Magsol</mat-label>
            <input matInput formControlName="magsolConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 0 && data.option == 0 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editCampaignForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Gunitadora</mat-label>
          <input matInput formControlName="dispUuid">
        </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Campaña</mat-label>
            <input matInput formControlName="campaignUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Nombre de Campaña</mat-label>
            <input matInput formControlName="campaignName">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="campaignStartDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="campaignEndDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 2 && data.option == 0 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editSteelProductionForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Gunitadora</mat-label>
          <input matInput formControlName="dispUuid">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Consumo de Acero</mat-label>
          <input matInput formControlName="steelConsumption">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Número de Coladas</mat-label>
          <input matInput formControlName="steelCastings">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 3 && data.option == 0 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editFrimagConsumptionForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Gunitadora</mat-label>
          <input matInput formControlName="dispUuid">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Consumo de Frimag</mat-label>
          <input matInput formControlName="frimagConsumption">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 4 && data.option == 0 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editMagsolConsumptionForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Gunitadora</mat-label>
          <input matInput formControlName="dispUuid">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Consumo de Magsol</mat-label>
          <input matInput formControlName="magsolConsumption">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 0 && data.option == 1 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      ¿Desea usted eliminar la Campaña <b>{{data.id}}</b>?<br/>
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
  <div *ngIf="data.type == 0 && data.option == 4 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <mat-grid-list cols="3" rowHeight="1:0.5">
        <mat-grid-tile>
          <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
            <mat-card-title style="padding: 10px 0 0px 20px;">KPI#1</mat-card-title>
            <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Impactor)</mat-card-subtitle>
            <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedProductQuantity/steelProductionQuantity)}}</mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
            <mat-card-title style="padding: 10px 0 0px 20px;">KPI#2</mat-card-title>
            <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Frimag)</mat-card-subtitle>
            <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedFrimagQuantity/steelProductionQuantity)}}</mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
            <mat-card-title style="padding: 10px 0 0px 20px;">KPI#3</mat-card-title>
            <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Magsol)</mat-card-subtitle>
            <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedMagsolQuantity/steelProductionQuantity)}}</mat-card-content>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
  <div *ngIf="data.type == 2 && data.option == 1 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      ¿Desea usted eliminar la entrada de producción de acero <b>{{data.id}}</b>?<br/>
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
  <div *ngIf="data.type == 3 && data.option == 1 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      ¿Desea usted eliminar la entrada de consumo <b>{{data.id}}</b>?<br/>
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
  <div *ngIf="data.type == 4 && data.option == 1 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      ¿Desea usted eliminar la entrada de consumo <b>{{data.id}}</b>?<br/>
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
  <div *ngIf="data.option == 2 && data.type == 0" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <table mat-table [dataSource]="dataSourceAlarmsByCampaign" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="alarma">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Alarma </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.alarma}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fecha </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fecha/1000000)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAlarmsByCampaign"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsAlarmsByCampaign;"></tr>
      </table>
      <mat-paginator #campaignAlarmsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <div *ngIf="data.option == 4 && data.type == 1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <table mat-table [dataSource]="dataSourceAlarmsByOperation" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="alarma">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Alarma </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.alarma}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fecha </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fecha/1000000)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAlarmsByOperation"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsAlarmsByOperation;"></tr>
      </table>
      <mat-paginator #operationAlarmsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <div *ngIf="data.option == 2 && data.type == 1">
    <plotly-plot
      [data]="data.product_graph_data.data"
      [layout]="data.product_graph_data.layout"
      [useResizeHandler]="true">
    </plotly-plot>
    <plotly-plot
      [data]="data.product_heatmap_data.data"
      [layout]="data.product_heatmap_data.layout"
      [useResizeHandler]="true">
    </plotly-plot>
  </div>
  <div *ngIf="data.option == 3 && data.type == 1">
    <plotly-plot
      [data]="data.water_graph_data.data"
      [layout]="data.water_graph_data.layout"
      [useResizeHandler]="true">
    </plotly-plot>
    <plotly-plot
      [data]="data.water_heatmap_data.data"
      [layout]="data.water_heatmap_data.layout"
      [useResizeHandler]="true">
    </plotly-plot>
  </div>
  <!-- Report: Operation -->
  <div *ngIf="data.option == 5 && data.type == 1" id="of_report"> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <div style="width: 100%; border-bottom: 1px solid #ededed;" id="report_header">
        <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Datos</div>
        <div id="report_logo" style="float: left; width: 30%; padding: 5px;">
          <img src="/assets/images/logo-magna.png" style="width: 92%;"/>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">UUID</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.uuid}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Inicio</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.start*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Fin</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.end*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Duración</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.duration}}</div>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Campaña</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.campaign}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Producto</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doRoundNumber(data.report.product)}} kgs</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Agua</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doRoundNumber(data.report.water)}} lts</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarmas</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.alarms.length}}</div>
        </div>
        <div style="clear: both; height: 1px;"></div>
      </div>
      <div>
        <div>
          <div id="report_graph_product">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Producto</div>
            <plotly-plot
              [data]="data.product_graph_data.data"
              [layout]="data.product_graph_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            <plotly-plot
              [data]="data.product_heatmap_data.data"
              [layout]="data.product_heatmap_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
          </div>
          <div id="report_graph_water">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Agua</div>
            <plotly-plot
              [data]="data.water_graph_data.data"
              [layout]="data.water_graph_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            <plotly-plot
              [data]="data.water_heatmap_data.data"
              [layout]="data.water_heatmap_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
          </div>
          <div id="report_alarms">
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length > 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas</div>
              <div style="padding: 5px;">
                <div style="width: 10%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">#</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarma</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Fecha</div>
                <div *ngFor="let item of data.report.alarms; index as i">
                  <div style="width: 10%; padding: 5px; float: left; text-align: center">{{i+1}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{item.alarma}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{doTransformDate(item.fecha/1000000)}}</div>
                </div>
                <div style="clear: both; height: 1px"></div>
                <plotly-plot
                  [data]="data.pie_data.data"
                  [layout]="data.pie_data.layout"
                  [useResizeHandler]="true">
                </plotly-plot>
              </div>
            </div>
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length == 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas</div>
              <div style="padding: 5px;">
                <p>No hay alarmas</p>
              </div>
            </div>
          </div>
        </div>
      <!--
      <div style="width: 100%; border-top: 1px solid #ededed; text-align: right; padding: 10px;" id="report_footer">
        {{data.date}}
      </div>
      -->
      </div>
    </div>
  </div>
  <!-- Report: Campaign-->
  <div *ngIf="data.option == 3 && data.type == 0" id="of_report_campaign"> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <div style="width: 100%; border-bottom: 1px solid #ededed;" id="report_header">
        <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Datos</div>
        <div id="report_logo" style="float: left; width: 30%; padding: 5px;">
          <img src="/assets/images/logo-magna.png" style="width: 92%;"/>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">UUID</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.uuid}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Inicio</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.start*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Fin</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.end*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Duración</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.duration}}</div>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Operaciones</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.operations}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarmas</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.alarms.length}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Producto</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doRoundNumber(consumedProductQuantity)}} Kgs</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Agua</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doRoundNumber(consumedWaterQuantity)}} Lts</div>
        </div>
        <div style="clear: both; height: 1px;"></div>
      </div>
      <div>
        <div>
          <div id="report_graph_operations">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Operaciones (Listado)</div>
            <!-- Intervals Table -->
            <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
              <table mat-table [dataSource]="dataSourceOperationsByCampaign" class="mat-elevation-z8">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Name Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="inicio">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="fin">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="duracion">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Duración </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.fin - element.inicio}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="producto">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Producto </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campos.productoGunitadoTotal}} kgs</td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="agua">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Agua </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.peticionAgua.total)}} lts</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsOperationsByCampaign"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsOperationsByCampaign;"></tr>
              </table>
              <mat-paginator #operationsCampaignPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
            <div id="report_graph_operations_chart">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Operaciones (Gráfica)</div>
              <!-- Intervals Gantt Chart -->
              <plotly-plot
                [data]="data.operations_gantt_data.data"
                [layout]="data.operations_gantt_data.layout"
                [useResizeHandler]="true">
              </plotly-plot>
            </div>
          </div>
          <div id="report_kpis">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">KPIs</div>
            <div style="padding: 5px;">
              <mat-grid-list cols="3" rowHeight="1:0.5">
                <mat-grid-tile>
                  <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
                    <mat-card-title style="padding: 10px 0 0px 20px;">KPI#1</mat-card-title>
                    <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Impactor)</mat-card-subtitle>
                    <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedProductQuantity/steelProductionQuantity)}}</mat-card-content>
                  </mat-card>
                </mat-grid-tile>
                <mat-grid-tile>
                  <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
                    <mat-card-title style="padding: 10px 0 0px 20px;">KPI#2</mat-card-title>
                    <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Frimag)</mat-card-subtitle>
                    <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedFrimagQuantity/steelProductionQuantity)}}</mat-card-content>
                  </mat-card>
                </mat-grid-tile>
                <mat-grid-tile>
                  <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
                    <mat-card-title style="padding: 10px 0 0px 20px;">KPI#3</mat-card-title>
                    <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Magsol)</mat-card-subtitle>
                    <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedMagsolQuantity/steelProductionQuantity)}}</mat-card-content>
                  </mat-card>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
          </div>
          <div id="report_graph_product">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Consumos Acumulados de Producto</div>
            <!--
            <plotly-plot
              [data]="data.product_graph_data.data"
              [layout]="data.product_graph_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            -->
            <plotly-plot
              [data]="data.product_heatmap_data.data"
              [layout]="data.product_heatmap_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
          </div>
          <div id="report_graph_water">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Consumos Acumulados de Agua</div>
            <!--
            <plotly-plot
              [data]="data.water_graph_data.data"
              [layout]="data.water_graph_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            -->
            <plotly-plot
              [data]="data.water_heatmap_data.data"
              [layout]="data.water_heatmap_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
          </div>
          <div id="report_alarms">
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length > 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas (Listado)</div>
              <div style="padding: 5px;">
                <div style="width: 10%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">#</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarma</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Fecha</div>
                <div *ngFor="let item of data.report.alarms; index as i">
                  <div style="width: 10%; padding: 5px; float: left; text-align: center">{{i+1}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{item.alarma}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{doTransformDate(item.fecha/1000000)}}</div>
                </div>
                <div style="clear: both; height: 5px"></div>
                <div id="report_alarms_chart">
                  <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas (Gráfica)</div>
                  <plotly-plot
                    [data]="data.pie_data.data"
                    [layout]="data.pie_data.layout"
                    [useResizeHandler]="true">
                  </plotly-plot>
                </div>
              </div>
            </div>
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length == 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas</div>
              <div style="padding: 5px;">
                <p>No hay alarmas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div style="width: 100%; border-top: 1px solid #ededed; text-align: right; padding: 10px;" id="report_footer">
        {{data.date}}
      </div>
      -->
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.type == 0 && data.option == -1 && data.id == -1" mat-raised-button color="primary" (click)="doAddCampaign()">Añadir</button>
  <button *ngIf="data.type == 0 && data.option == 0" mat-raised-button color="primary" (click)="doEditCampaign(data.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 0 && data.option == 1" mat-raised-button color="primary" (click)="doRemoveCampaign(data.disp, data.id)">Eliminar</button>
  <button *ngIf="data.type == 2 && data.option == -1 && data.id == -1" mat-raised-button color="primary" (click)="doAddSteelProduction()">Añadir</button>
  <button *ngIf="data.type == 2 && data.option == 0" mat-raised-button color="primary" (click)="doEditSteelProduction(data.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 2 && data.option == 1" mat-raised-button color="primary" (click)="doRemoveSteelProduction(data.disp, data.id)">Eliminar</button>
  <button *ngIf="data.type == 3 && data.option == -1 && data.id == -1" mat-raised-button color="primary" (click)="doAddFrimagConsumption()">Añadir</button>
  <button *ngIf="data.type == 3 && data.option == 0" mat-raised-button color="primary" (click)="doEditFrimagConsumption(data.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 3 && data.option == 1" mat-raised-button color="primary" (click)="doRemoveFrimagConsumption(data.disp, data.id)">Eliminar</button>
  <button *ngIf="data.type == 4 && data.option == -1 && data.id == -1" mat-raised-button color="primary" (click)="doAddMagsolConsumption()">Añadir</button>
  <button *ngIf="data.type == 4 && data.option == 0" mat-raised-button color="primary" (click)="doEditMagsolConsumption(data.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 4 && data.option == 1" mat-raised-button color="primary" (click)="doRemoveMagsolConsumption(data.disp, data.id)">Eliminar</button>
  <button *ngIf="data.option == 5 && data.type == 1" mat-raised-button color="primary" (click)="doPrintOperationReport()" [disabled]="!isPrintEnabled">Imprimir</button>
  <button *ngIf="data.option == 3 && data.type == 0" mat-raised-button color="primary" (click)="doPrintCampaignReport()" [disabled]="!isPrintEnabled">Imprimir</button>
  <button *ngIf="!data.wait" mat-raised-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>